import React, { CSSProperties } from 'react';
import { LAYOUT_CONSTANTS } from '../hooks/useLayout';

export type LayOutBodyType = {
  contentAreaStyle: CSSProperties;
  children: React.ReactNode;
};
const LayOutBody: React.FC<LayOutBodyType> = ({
  contentAreaStyle,
  children,
}) => {
  return (
    <div
      id="main-content"
      role="main"
      className="bg-neutral-90 rounded-tl-3xl p-5 transition-all duration-300 flex flex-col overflow-hidden"
      style={{
        ...contentAreaStyle,
        position: 'relative',
        zIndex: 10,
        height: `calc(100vh - ${LAYOUT_CONSTANTS.HEADER_HEIGHT})`,
        marginTop: LAYOUT_CONSTANTS.HEADER_HEIGHT,
      }}
    >
      <div className="flex-1 min-h-0 flex flex-col">{children}</div>
    </div>
  );
};

export default LayOutBody;
